import { useContext } from "react";
import { PurchasesContext } from "../context/PurchasesContext";
import { useMemo } from "react";
import { useEffect } from "react";

const useRewards = () => {
  const { purchases, getPurchases } = useContext(PurchasesContext);
  
  useEffect(() => {
    getPurchases();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activePurchase = useMemo(
    () => purchases?.find(({ status }) => status === "active"),
    [purchases]
  );
  const isPresencial = useMemo(
    () =>
      activePurchase?.class_amount > 0 && activePurchase?.class_amount !== null,
    [activePurchase]
  );
  const canRedeemRewards = useMemo(
    () => (isPresencial && activePurchase?.class_amount >= 12) || !isPresencial,
    [activePurchase, isPresencial]
  );
  return {
    activePurchase,
    isPresencial,
    canRedeemRewards,
  };
};

export default useRewards;
